/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type DistributionBarChart_question = {|
  +type: ?string;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DistributionBarChart_question",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "type",
      "storageKey": null
    }
  ],
  "type": "Question"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/DistributionBarChart/__generated__/DistributionBarChart_question.graphql.js